<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Article Category">
      <!-- <b-card-text>Job Category.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Category -->
            <b-col cols="12">
              <b-form-group label="Category" label-for="v-level">
                <validation-provider #default="{ errors }"  name="Category" rules="required">
                  <b-form-input  id="v-Category-name" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Category" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Desc -->
            <b-col cols="12">
              <b-form-group label="Desc" label-for="v-profession">
                <validation-provider #default="{ errors }"  name="Desc" rules="required">
                  <b-form-input  id="v-Desc-name" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Desc" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, text_1: '',text_2: ''},
      show: false,
      required 
    }
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('articleCategory/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('articleCategory/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.desc
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>